/* eslint-disable @typescript-eslint/no-explicit-any */
import DataStore from '../support/DataStore';
import IndexedList from '../support/shared/IndexedList';

import SignupFormModel from '../components/FormBuilder/SignupFormModel';
import { FormField } from '../components/FormBuilder/FormElements/types/FormField';
import { Group } from '../types/shared/Group';

const dataStore = DataStore.getInstance('app');

class FormBuilderActions {
  static updateForm(form: SignupFormModel, name: string, value: any) {
    let updates = { [name]: value };
    dataStore.setX('forms/:id', [form.id], form.update(updates));
  }

  static updateFeeOption(
    form: SignupFormModel,
    feeOption: string,
    feeValue: number,
  ) {
    let updates = { feeOption, feeValue };
    dataStore.setX('forms/:id', [form.id], form.update(updates));
  }

  static addField(formField: FormField) {
    let form = dataStore.getX('forms/:id', [formField.formID]);
    if (!form) {
      return;
    }
    let fields = form.fields.push(formField);
    dataStore.setX('forms/:id', [formField.formID], form.update({ fields }));
  }

  static addFieldBelow(formField: FormField, addBelowFieldID: string) {
    let form = dataStore.getX('forms/:id', [formField.formID]);
    if (!form) {
      return;
    }
    let newFields = [];
    for (let field of form.fields.getList()) {
      newFields.push(field);
      if (field.id === addBelowFieldID) {
        newFields.push(formField);
      }
    }
    dataStore.setX(
      'forms/:id',
      [formField.formID],
      form.update({ fields: new IndexedList(newFields) }),
    );
  }

  static updateField(formField: FormField, updates: any) {
    let form = dataStore.getX('forms/:id', [formField.formID]);
    if (!form) {
      return;
    }
    let index = form.fields.getIndexByID(formField.id);
    if (index === -1) {
      throw new Error(t('Unable to find field in data store.'));
    }
    let newField = formField.update(updates);
    let fields = form.fields.setByIndex(index, newField as FormField);
    dataStore.setX('forms/:id', [formField.formID], form.update({ fields }));
  }

  static removeField(formField: FormField) {
    let form = dataStore.getX('forms/:id', [formField.formID]);
    if (!form) {
      return;
    }
    let index = form.fields.getIndexByID(formField.id);
    if (index === -1) {
      throw new Error(t('Unable to find field in data store.'));
    }
    let fields = form.fields.splice(index, 1);
    dataStore.setX('forms/:id', [formField.formID], form.update({ fields }));
  }

  static saveFieldGroup(group: Group) {
    let form = dataStore.getX('forms/:id', ['signup']);
    if (!form) {
      return;
    }
    let oldGroupList = form.groups || [];
    let isFound = false;
    let newGroupList = oldGroupList.map((g: any) => {
      if (g.id === group.id) {
        isFound = true;
        return group;
      } else {
        return g;
      }
    });
    if (!isFound) {
      newGroupList.push(group);
    }
    dataStore.setX(
      'forms/:id',
      ['signup'],
      form.update({ groups: newGroupList }),
    );
  }

  static removeFieldGroup(group: Group) {
    let form = dataStore.getX('forms/:id', ['signup']);
    if (!form) {
      return;
    }
    let oldGroupList = form.groups || [];
    let newGroupList = oldGroupList.filter((g: any) => g.id !== group.id);
    dataStore.setX(
      'forms/:id',
      ['signup'],
      form.update({ groups: newGroupList }),
    );
  }
}

export default FormBuilderActions;
